import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Directive, NgModule } from '@angular/core';
import * as i1 from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i3 from '@xpo-ltl/ngx-ltl-core/icon';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

class XpoDialogCloseButtonComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
    }
    closeDialog() {
        this.dialogRef.close();
    }
}
XpoDialogCloseButtonComponent.ɵfac = function XpoDialogCloseButtonComponent_Factory(t) { return new (t || XpoDialogCloseButtonComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef)); };
XpoDialogCloseButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoDialogCloseButtonComponent, selectors: [["xpo-dialog-close-button"]], hostAttrs: [1, "xpo-DialogCloseButton"], decls: 2, vars: 0, consts: [["role", "button", "mat-icon-button", "", 3, "click"], ["iconName", "close", "xpoIconLarge", ""]], template: function XpoDialogCloseButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function XpoDialogCloseButtonComponent_Template_button_click_0_listener() { return ctx.closeDialog(); });
        i0.ɵɵelement(1, "xpo-icon", 1);
        i0.ɵɵelementEnd();
    } }, directives: [i2.MatButton, i3.XpoIcon, i3.XpoIconLarge], styles: [".flex--stretch{flex:1}.xpo-DialogCloseButton{display:flex}.xpo-DialogCloseButton .mat-icon-button{height:auto;line-height:24px;width:auto}.xpo-DialogCloseButton .mat-icon-button,.xpo-DialogCloseButton .mat-icon-button:hover,.xpo-DialogCloseButton .mat-icon-button:focus{color:#4a4a4a}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDialogCloseButtonComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-dialog-close-button',
                templateUrl: './dialog-close-button.component.html',
                styleUrls: ['./dialog-close-button.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-DialogCloseButton' },
            }]
    }], function () { return [{ type: i1.MatDialogRef }]; }, null); })();

class XpoDialogDirective {
}
XpoDialogDirective.ɵfac = function XpoDialogDirective_Factory(t) { return new (t || XpoDialogDirective)(); };
XpoDialogDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoDialogDirective, selectors: [["", "xpo-dialog", ""], ["", "xpoDialog", ""]], hostAttrs: [1, "xpo-Dialog-container"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDialogDirective, [{
        type: Directive,
        args: [{
                selector: '[xpo-dialog], [xpoDialog]',
                host: {
                    class: 'xpo-Dialog-container',
                },
            }]
    }], null, null); })();

class XpoDialogModule {
}
XpoDialogModule.ɵfac = function XpoDialogModule_Factory(t) { return new (t || XpoDialogModule)(); };
XpoDialogModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoDialogModule });
XpoDialogModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, MatButtonModule, MatIconModule, XpoIconModule], MatDialogModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDialogModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, MatButtonModule, MatIconModule, XpoIconModule],
                declarations: [XpoDialogCloseButtonComponent, XpoDialogDirective],
                exports: [XpoDialogCloseButtonComponent, MatDialogModule, XpoDialogDirective],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoDialogModule, { declarations: [XpoDialogCloseButtonComponent, XpoDialogDirective], imports: [CommonModule, MatButtonModule, MatIconModule, XpoIconModule], exports: [XpoDialogCloseButtonComponent, MatDialogModule, XpoDialogDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoDialogCloseButtonComponent, XpoDialogDirective, XpoDialogModule };
